var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"new-event-wooba-flight-reservation"},[_c('div',{staticClass:"new-event-wooba-flight-reservation__inner new-layout-container"},[_c('iframe',{ref:"woobaFrame",staticClass:"new-event-wooba-flight-reservation__frame",attrs:{"src":_vm.woobaUrl,"title":_vm.title,"frameborder":"0"},on:{"load":_vm.handleFrameLoad}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79627a02","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/WoobaFlightReservation.vue
// module id = 1086
// module chunks = 0